import { makeStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  bold: {
    fontFamily: "Helvetica Neue LT W05_75 Bold",
  },
}));
